export default __webpack_public_path__ + "static/media/blobBackground.ffde1b5b.jpeg";